/**
 * Performance Alerts — Redux module
 *
 * Backend contract (for the backend dev mirroring this):
 *
 *   GET    /performance-alerts                  -> { alerts: AlertRule[] }
 *   POST   /performance-alerts                  body: AlertRuleDraft -> AlertRule
 *   PUT    /performance-alerts/:id              body: Partial<AlertRule> -> AlertRule
 *   DELETE /performance-alerts/:id              -> { id }
 *   PATCH  /performance-alerts/:id/toggle       body: { enabled } -> AlertRule
 *
 * AlertRule shape:
 *   {
 *     _id:       string,
 *     companyId: string,
 *     name:      string,
 *     enabled:   boolean,
 *     trigger: {
 *       condition: "above_yeti" | "below_yeti" | "above_target" | "below_target"
 *                | "improvement" | "decline" | "reached_goal",
 *       kpiId:     string | "any",
 *       threshold: number | null,
 *     },
 *     recipients: {
 *       userIds:    string[],   // technician _ids
 *       teams:      string[],   // team names
 *       workspaces: string[],   // workspace (group) _ids — server expands
 *                               // these into every active user with that
 *                               // groupId at send time
 *     },
 *     schedule: {
 *       frequency:  "daily" | "weekly" | "realtime",
 *       time:       string,           // "HH:MM" 24h
 *       daysOfWeek: number[],         // 0=Sun..6=Sat
 *       timezone:   string,
 *     },
 *     channels: { sms: boolean, inApp: boolean, email: boolean },
 *     message:    string,
 *     createdAt:  string,
 *     updatedAt:  string,
 *     lastSentAt: string | null,
 *   }
 *
 * Until the backend lands, the saga persists to localStorage so the admin
 * UI can be designed, demoed, and reviewed end-to-end.
 */

export const initState = {
  list: [],
  loading: false,
  saving: false,
  error: null,
};

export const types = {
  GET_ALERTS_REQUEST: "PERF_ALERTS/GET_REQUEST",
  GET_ALERTS_SUCCESS: "PERF_ALERTS/GET_SUCCESS",
  GET_ALERTS_FAILED: "PERF_ALERTS/GET_FAILED",

  CREATE_ALERT_REQUEST: "PERF_ALERTS/CREATE_REQUEST",
  CREATE_ALERT_SUCCESS: "PERF_ALERTS/CREATE_SUCCESS",
  CREATE_ALERT_FAILED: "PERF_ALERTS/CREATE_FAILED",

  UPDATE_ALERT_REQUEST: "PERF_ALERTS/UPDATE_REQUEST",
  UPDATE_ALERT_SUCCESS: "PERF_ALERTS/UPDATE_SUCCESS",
  UPDATE_ALERT_FAILED: "PERF_ALERTS/UPDATE_FAILED",

  DELETE_ALERT_REQUEST: "PERF_ALERTS/DELETE_REQUEST",
  DELETE_ALERT_SUCCESS: "PERF_ALERTS/DELETE_SUCCESS",
  DELETE_ALERT_FAILED: "PERF_ALERTS/DELETE_FAILED",

  TOGGLE_ALERT_REQUEST: "PERF_ALERTS/TOGGLE_REQUEST",
  TOGGLE_ALERT_SUCCESS: "PERF_ALERTS/TOGGLE_SUCCESS",
  TOGGLE_ALERT_FAILED: "PERF_ALERTS/TOGGLE_FAILED",
};
